<template>
  <section>
    <!-- Listing Header -->
    <challenges-header @search="search" @add="addChallenge" />
    <!-- Listing -->
    <div class="custom-wrapper">
      <div class="custom-add">
        <!-- <button class="btn btn-primary btn-sm" @click="addChallenge">
          Add
        </button> -->
      </div>
      <z-table
        :value="challenges"
        :columns="tableColumns"
        :isSingleRowDetail="false"
        class="table table-bordered table-striped"
        detailColumnClass="z-column-60-center"
        @sort="setOrder"
        :loading="isLoading"
      >
        <template v-slot:tbody="props">
          <th scope="row" class="z-column-60-center">{{ props.row.id }}</th>
          <td class="z-column-60-center">
            <a href="#" @click="getChallenge(props.row)">edit</a>
          </td>
          <td>{{ props.row.name }}</td>
          <td class="z-column-160-center">
            {{ formatDate(props.row.start_date) }}
          </td>
          <td class="z-column-160-center">
            {{ formatDate(props.row.end_date) }}
          </td>
          <td class="z-column-160-center">
            {{ formatClosed(props.row.closed) }}
          </td>
          <td>
            <button class="btn btn-link" @click="remove(props.row)">
              remove
            </button>
          </td>
        </template>
        <template v-slot:empty> Nothing found! </template>
      </z-table>
    </div>
    <challenge-dialog
      id="challenge-modal"
      :show="actionChallenge"
      @close="closeChallenge"
      @saved="savedChallenge"
    />
    <confirm-remove
      :show="actionConfirmRemove"
      :confirmTitle="confirmTitleRemove"
      :confirmAction="confirmActionRemove"
      :confirmQuestion="confirmQuestionRemove"
      @closing="closeModal"
      @proceed="performRemove"
    />
  </section>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import moment from 'moment'
import ZTable from '@/Components/ZElements/Table'
import ChallengesHeader from '@/Components/Challenges/challenges-header'
import ChallengeDialog from '@/Components/Challenges/forms/challenge-dialog'
import ConfirmRemove from '@/Components/ZElements/ConfirmDialog'
export default {
  name: 'challenge-listing',
  components: {
    ZTable,
    ChallengesHeader,
    ChallengeDialog,
    ConfirmRemove,
  },
  data() {
    return {
      page: 1,
      actionChallenge: null,
      isLoading: false,
      confirmTitleRemove: 'Confirm Removal',
      confirmActionRemove: 'Remove',
      confirmQuestionRemove: 'Are you sure you wish to remove this Challenge?',
      actionConfirmRemove: null,
      itemId: null,
    }
  },
  async mounted() {
    this.isLoading = false
    this.itemId = null
    this.setPager({
      name: 'page',
      value: 1,
    })
    this.setPager({
      name: 'search',
      value: '',
    })
    // await this.getChallengeName(this.examineOrganization.id)
    await this.search()
  },
  computed: {
    ...mapGetters('organizations', ['examineOrganization']),
    ...mapGetters('challenges', [
      'challenges',
      'challenge',
      'pager',
      'challengeName',
    ]),
    tableColumns() {
      return [
        {
          field: 'id',
          label: 'Id',
          sortable: false,
          class: 'z-column-60-center',
        },
        {
          field: 'id',
          label: '',
          sortable: false,
          class: 'z-column-60-center',
        },
        { field: 'name', label: 'Name', sortable: true },
        {
          field: 'start_date',
          label: 'Start',
          sortable: true,
          class: 'z-column-160-center',
        },
        {
          field: 'end_date',
          label: 'End',
          sortable: true,
          class: 'z-column-160-center',
        },
        {
          field: 'closed',
          label: 'Closed?',
          sortable: true,
          class: 'z-column-160-center',
        },
        {
          field: 'id',
          label: '',
          sortable: false,
          class: 'z-column-60-center',
        },
      ]
    },
  },
  methods: {
    ...mapActions('challenges', [
      'getChallenges',
      'editChallenge',
      'resetChallenge',
      'removeChallenge',
      'getChallengeName',
      'setPager',
    ]),
    async setOrder(column, order) {
      this.setPager({
        name: 'sortBy',
        value: column.field,
      })
      this.setPager({
        name: 'orderBy',
        value: order,
      })
      await this.search()
    },
    async search() {
      try {
        await this.getChallenges({
          page: this.pager.page,
          pageSize: this.pager.pageSize,
          sortBy: this.pager.sortBy,
          orderBy: this.pager.orderBy,
          search: this.pager.search,
          orgId: this.examineOrganization.id,
        })
        window.app.$forceUpdate()
      } catch (e) {
        console.log('Error', e)
      }
    },
    formatClosed(closed) {
      return closed ? 'Y' : ''
    },
    formatDate(date) {
      return moment.utc(new Date(date)).format('MM/DD/YYYY')
    },
    closeChallenge() {
      this.actionChallenge = null
    },
    closeModal() {
      this.actionConfirmRemove = null
    },
    async savedChallenge() {
      await this.search()
    },
    async addChallenge() {
      let data = {
        id: null,
        name: null,
        orgId: this.examineOrganization.id,
      }
      this.resetChallenge(data)
      this.actionChallenge = {
        isAdd: true,
        data: null,
      }
    },
    remove(row) {
      console.log('Remove Challenge', row)
      this.itemId = row.id
      this.actionConfirmRemove = true
    },
    async performRemove() {
      this.actionConfirmRemove = null
      let data = {
        id: this.itemId,
        orgId: this.examineOrganization.id,
      }
      // Perform Removal
      await this.removeChallenge(data)
      this.search()
      this.itemId = null
    },
    async getChallenge(row) {
      let data = {
        id: row.id,
        name: row.name,
        orgId: this.examineOrganization.id,
      }
      await this.editChallenge(data.id)
      this.actionChallenge = {
        isAdd: false,
        data: data,
      }
    },
  },
}
</script>
<style lang='scss'>
.custom-wrapper {
  overflow-x: hidden;
  overflow-y: auto;
  position: relative;
}
.custom-add {
  position: absolute;
  top: 9px;
  left: 8px;
}
</style>
